/** localStorage kaliti — versiya oshsa ham o'zgarmaydi. */
export const THEME_STORAGE_KEY = 'eombor:theme';
const isThemeMode = (v) => v === 'light' || v === 'dark' || v === 'system';
/** Saqlangan temani o'qiydi; qiymat buzuq bo'lsa `system` ga qaytadi. */
export const readStoredTheme = (storage) => {
    const raw = storage.getItem(THEME_STORAGE_KEY);
    return isThemeMode(raw) ? raw : 'system';
};
/** Tizim qorong'i temani so'rayaptimi. */
export const prefersDark = () => globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
/**
 * `data-theme` atributini qo'yadi va hal qilingan temani qaytaradi.
 * `system` rejimida tizim sozlamasiga qaraydi.
 */
export const applyTheme = (mode, root = document.documentElement) => {
    const resolved = mode === 'system' ? (prefersDark() ? 'dark' : 'light') : mode;
    root.setAttribute('data-theme', resolved);
    return resolved;
};
//# sourceMappingURL=theme.js.map